import React from 'react';
import { NoResultsTemplateProps } from './NoResultsTemplate.types';

const NoResultsTemplate: React.FunctionComponent<NoResultsTemplateProps> = ({
  contentType = 'results',
}) => {
  return (
    <div dangerouslySetInnerHTML={{
      __html: `
        <p>
            <span>We couldn't find any ${contentType} on our directory that match your search.</span>
        </p>
        <p>
            <span>You can try again with a different search term or remove the postcode to view ${contentType === 'events' ? 'events' : 'support'} available across all of North Northamptonshire.</span>
        </p>
        <p>
            <span>You might also find what you need in one of our popular support categories:</span>
        </p>
        <ul>
            <li data-list-item-id="e22c4dc39c92119d26e70c62385849b39">
                <a href="https://www.northnorthants.gov.uk/directory/support-offer?page=1&amp;provider_category=204"><span>Children and families</span></a>
            </li>
            <li data-list-item-id="e4433aae6c1c132dc567a0033d721f23a">
                <a href="https://www.northnorthants.gov.uk/directory/support-offer?page=1&amp;provider_category=126"><span>Community groups</span></a>
            </li>
            <li data-list-item-id="e8258a989ae79b013fa3ddb0757487755">
                <a href="https://www.northnorthants.gov.uk/directory/support-offer?page=1&amp;provider_category=162"><span>Food support</span></a>
            </li>
            <li data-list-item-id="e2a5c68c4edd91b64635095e52910c320">
                <a href="https://www.northnorthants.gov.uk/directory/support-offer?page=1&amp;provider_category=135"><span>Housing</span></a>
            </li>
            <li data-list-item-id="e13fe4ab6d0899849a45a12873b28cdc7">
                <a href="https://www.northnorthants.gov.uk/directory/support-offer?page=1&amp;provider_category=195"><span>Mental health and wellbeing</span></a>
            </li>
            <li data-list-item-id="eb6c0dce58edbff50832aa0b10a7583d1">
                <a href="https://www.northnorthants.gov.uk/directory/support-offer?page=1&amp;provider_category=141"><span>Money, benefits and debt</span></a>
            </li>
            <li data-list-item-id="e4d9919952839158bd6c8428d3f1618d9">
                <a href="https://www.northnorthants.gov.uk/directory/support-offer?page=1&amp;provider_category=147"><span>Physical health and disabilities</span></a>
            </li>
            <li data-list-item-id="e75ec6e837465b16129ecb4e684de5916">
                <a href="https://www.northnorthants.gov.uk/directory/support-offer?page=1&amp;provider_category=198"><span>Sports, leisure and wellbeing</span></a>
            </li>
            <li data-list-item-id="e041fb0b546f99e164806e88766dafde2">
                <a href="https://www.northnorthants.gov.uk/directory/support-offer?page=1&amp;provider_category=150"><span>Work, education and volunteering</span></a>
            </li>
        </ul>
      `
    }} />
  );
};

export default NoResultsTemplate;